"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _moment = _interopRequireDefault(require("moment"));

var _lodash = _interopRequireDefault(require("lodash"));

var ScheduleAvailability = function ScheduleAvailability(_ref) {
  var availableDays = _ref.availableDays,
      startTime = _ref.startTime,
      endTime = _ref.endTime;
  var alwaysAvailable = availableDays.length === 1 && availableDays[0] === 'ALL';
  if (alwaysAvailable) return /*#__PURE__*/_react["default"].createElement("div", null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '2rem',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    as: "h5",
    style: {
      marginBottom: 0
    }
  }, "Available On:"), /*#__PURE__*/_react["default"].createElement("div", {
    as: "h6"
  }, availableDays.map(function (day, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: day
    }, _lodash["default"].startCase(day.toLowerCase()), index === availableDays.length - 1 ? '' : ', ');
  }), /*#__PURE__*/_react["default"].createElement("span", null, " from "), /*#__PURE__*/_react["default"].createElement("span", null, (0, _moment["default"])(startTime, 'HH:mm').format('h:mm A')), /*#__PURE__*/_react["default"].createElement("span", null, " to "), /*#__PURE__*/_react["default"].createElement("span", null, (0, _moment["default"])(endTime, 'HH:mm').format('h:mm A'))));
};

var _default = ScheduleAvailability;
exports["default"] = _default;